import Cookies from 'universal-cookie'
import add_icon from './img/add_icon.svg'
import close_icon from './img/close.svg'
import { useState, useEffect } from 'react';
import { MoonLoader } from 'react-spinners';
import useGeneralStore from '../../store/general';
import { useNavigate } from 'react-router-dom';
import { useResponseHandler } from '../../common/auth';
import "./DropZoneProductImg.scss"

const DropZoneProductImg = ({ ind, key, arrImg, setArrImg, notMainPhoto = true, saveCallback, isDrop = true }) => {

    // Обработка ошибок
    const { handleStatusCode } = useResponseHandler();

    const cookies = new Cookies()
    const token = cookies.get('auth')
    const [save, setSave] = useState(arrImg[ind])
    const [loading, setLoading] = useState(false)
    const [err, setErr] = useState(false)
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const navigate = useNavigate();

    useEffect(() => {
        setSave(arrImg[ind])
    }, [arrImg, ind])

    useEffect(() => {
        if (saveCallback) saveCallback()
    }, [save])

    const handleFileInput = async (e) => {
        const files = Array.from(e.target.files);

        if (files.length === 0) return;

        setLoading(true);
        setErr(false);

        const uploadedUrls = [];

        for (let file of files) {
            const fd = new FormData();
            fd.append('file', file);

            const url = `https://file.ecomru.ru:4453/api/v1/file/upload`;

            const requestHeaders = {
                'space': selectedSpace?.value,
                'Accept': 'application/json',
                'Cache-control': 'no-cache',
                'Authorization': `Bearer ${token}`
            };

            try {
                const res = await fetch(url, { body: fd, method: 'POST', headers: requestHeaders });

                if (handleStatusCode(res.status)) {
                    return;
                }

                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }

                const json = await res.json();

                if (json?.url) {
                    uploadedUrls.push(json.url);
                } else {
                    setErr(true);
                }
            } catch (err) {
                console.error(err);
                setErr(true);
            }
        }

        // Объединяем с существующими изображениями, но ограничиваем максимумом 15
        if (uploadedUrls.length > 0) {
            setArrImg(prev => {
                const newArr = [...prev, ...uploadedUrls];
                return newArr.slice(0, 15);
            });
        }

        setLoading(false);
    }


    const handleRemoveImage = (e) => {
        e.stopPropagation()
        setSave(null)

        // Создаем новый массив без мутации исходного
        const newArr = [...arrImg]
        newArr.splice(ind, 1) // или newArr.splice(ind, 1) если нужно полностью удалить позицию

        setArrImg(newArr)
    }


    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const files = Array.from(e.dataTransfer.files);
        if (files.length === 0) return;
        
        // Создаем объект события с файлами
        const fileEvent = {
            target: {
                files: files
            }
        };
        
        handleFileInput(fileEvent);
    }

    return (
        <div
            key={key}
            className={'file-box'}
            onMouseEnter={e => e.currentTarget.setAttribute('hover', true)}
            onMouseLeave={e => e.currentTarget.setAttribute('hover', false)}
            onDragOver={isDrop && handleDragOver}
            onDrop={isDrop && handleDrop}
        >
            {
                <>
                    {
                        loading ?
                            <div className='center' style={{ width: '100%', height: '86px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <MoonLoader
                                    size={20}
                                    color="#7b7b7b"
                                    speedMultiplier={0.5}
                                />
                            </div>
                            :
                            ((save || arrImg[ind]) ?
                                <img className='image' src={save || arrImg[ind]} alt={`Product ${ind}`} />
                                :
                                <img className='icon-add' src={add_icon} alt="Add icon" />
                            )
                    }

                    <input
                        type='file'
                        accept='image/png, image/jpg, image/jpeg'
                        multiple={true}
                        className='input-file'
                        onChange={(e) => {
                            setLoading(true)
                            handleFileInput(e)
                        }}
                    />

                    {(save || arrImg[ind]) &&
                        <div className='close-box'>
                            <button
                                className='close-btn'
                                onClick={handleRemoveImage}
                            >
                                <img src={close_icon} alt="Close icon" />
                            </button>
                        </div>
                    }
                </>
            }
        </div>
    )
}

export { DropZoneProductImg }